import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../Layout.tsx";
import { getContacts } from "../../../data/contacts";
import { Contact } from "../../../types/Contact";
import { showModal } from "../../../data/modal";
import Modal from "../../Modal.tsx";

import {
  Button,
  Grid,
  IconButton,
  Paper,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Typography,
} from "@mui/material";

import { 
  Edit as EditIcon,
} from "@mui/icons-material";
import SettingsMenu from "../Menu";

const ContactManage = () => {
  const dispatch = useDispatch();

  const selectedData = useSelector((state) => ({
    contacts: state.contacts,
  }));

  useEffect(() => {
    dispatch(getContacts());
  }, [dispatch]);

  const { contacts } = selectedData;

  return (
    <Layout>
    <Modal/>
    <Grid container>
      <Grid item xs={12} sm={2} padding={1}>
        <Grid item component={ Paper }  sx={{ height: 'auto' }}>
          <SettingsMenu activeMenu={ 'contact' }/>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={10} padding={1}>
        <Grid item component={ Paper }  sx={{ height: 'auto' }}>
          <Grid className='settings-page-header' item xs={12} sm={12} padding={1}>
            <Grid item>
              <Typography variant="h6" gutterBottom>
                Contact
              </Typography>
            </Grid>
            <Grid item>
              <Button 
                  variant='contained'
                  size='small'
                  onClick={() => {
                    dispatch(
                      showModal({
                        title: "Add contact",
                        description: "Creates a new contact",
                        form: "contact",
                      })
                    );
                  }}
                >
                Add Contact
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} padding={1}>
          <Grid item>
            <TableContainer sx={{ height: '80vh', overflow: "auto" }}>
              <Table aria-label="terminal table" stickyHeader>
                <TableHead>
                    <TableRow>
                      <TableCell>
                        Name
                      </TableCell>
                      <TableCell align='center'>
                        Phone number
                      </TableCell>
                      <TableCell align='center'>
                        Email
                      </TableCell>
                      <TableCell>
                        Address
                      </TableCell>
                      <TableCell align='right'></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                      { contacts && contacts.data.length !== 0 && contacts.data.map((contact: Contact) => (
                        <TableRow className='js-collection-item' data-object-id={ contact['@id'] }>
                          <TableCell>{ contact.name  }</TableCell>
                          <TableCell align='center'>{ contact.phoneNumber }</TableCell>
                          <TableCell align='center'>{ contact.email }</TableCell>
                          <TableCell>
                            { contact?.address !== undefined ? (
                                <>
                                  { `${ contact.address.number ?? '' } ${ contact.address.street ?? '' }, ${ contact.address.postalCode ?? '' } ${ contact.address.city ?? '' }` }<br />
                                  { `${ contact.address.country ?? '' }` }
                                </>
                            ) : '' }   
                          </TableCell>
                          <TableCell align='right'>
                            <IconButton onClick={() => {
                              dispatch(
                                showModal({
                                  title: "Add contact",
                                  description: "Creates a new contact",
                                  form: "contact",
                                  formProps: { contact: contact },
                                })
                              );
                            }}>
                              <EditIcon size='small'/> 
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    </Layout>
  );
};

export default ContactManage;
